export default {
    nav: {
        // 顶部栏
        vision: '构建万物互联的智能工厂',
        walk: '走进一道',
        product: '产品中心',
        case: '客户案例',
        introduce: '公司介绍',
        recruitment: '人才招聘',
        contact: '联系我们',
        // 底部栏
        company: "深圳一道创新技术有限公司",
        telephone: '电话',
        phone: '手机',
        email: '邮箱',
        shenzhen: '',
        suzhou: '',
    },
    home: {
        // 首页
        who: '一道是谁',
        about: "一道创新成立于2012年，是一家创新型软件及信息技术服务商，“双高新”企业（国家高新&深圳高新技术企业），是中国智能制造探索者和践行者，致力于制造细分行业—电子制造业的数字化转型服务，构建万物互联的智能工厂。",
        about2: '一道创新致力于把先进的软件系统、数字平台、人工智能赋能智能工厂，让无处不在的联接成为智能工厂的基础，让企业因强大的数字平台而变得敏捷、高效，推动传统的制造业向服务型制造业转型，拉近消费者与制造工厂的距离，为消费者提供个性化智慧制造服务。',
        industry: "我们能为行业做些什么",
        wms: "WMS仓储管理系统",
        wms_system: "原材料管理｜半成品管理｜成品管理｜数据同步报表分析｜物流集成｜智能仓储联动",
        mes: "MES制造执行系统",
        mes_system: "生产管理｜工程管理｜防错追溯｜质量管理报表管理｜可视化｜数字孪生",
        npm: "NPM试制管理系统",
        npm_system: "试制准备｜工程评审｜试制验证｜数据固化转产导入｜知识库共享",
        iiot: "IIoT工业物联网平台",
        iiot_system: "覆盖90种设备｜工控互联｜数据采集｜智能仓储印刷机/贴片机/SPI/AOI/回流炉/ICT/FCT",
        npi: "NPI新产品导入",
        npi_system: "DFM 3D仿真｜SMT智能编程｜DFT 测试分析NPI 协同管理｜Stencil Designer｜钢网设计DFX数字化样机"
    },
    product: {
        // 产品中心
        wms: {
            choose: "为什么选择一道WMS",
            time: "实时物联",
            detailed: "丰富的IoT接口，支持智能硬件快速对接，实现智能仓库管理系统",
            print: "协同打印",
            print_detailed: "集成云端打印平台(E-printing),支持供应链伙伴协同打印",
            link: "全域连接",
            link_detailed: "丰富的ERP、SCM等系统连接方案，实时数据交互，高效统一",
            data: "大数据应用",
            data_detailed: "采用行业领先的工业大数据平台解决方案，满足数字化处理需求，稳定高效",
            modular: "模块化",
            modular_detailed: "开放平台，微服务集群架构，低耦合，高扩展性，搭建应用如同搭积木一样简单",
            flexible: "部署灵活",
            flexible_detailed: "支持云上部署、本地化部署，跨地域多区域部署",
            architecture: "行业领先的产品架构",
            architecture_detailed: " WMS采用行业领先的微服务B/S架构，部署灵活，支持智能硬件与三方系统快速对接，可进行协同管理，提升仓库数字化效率，是智能仓库系统解决方案的最佳选择。",
            features: "全面的功能特性",
            features_detailed: "十大功能特性，在满足基本物料管理的条件下，也可进行先进先出、调拨移库、工单合并与拆分等特殊管控，同时提供丰富的报表与图形看板，高效实现仓库数字化。",
        },
        mes: {
            choose: "为什么选择一道MES",
            time: "全流程数字化管理",
            detailed: "通过内建丰富的模型，将海量生产数据处理后，以数字化的方式复现出来，生产管理高效智能",
            print: "业务中台技术",
            print_detailed: "支持企业业务中台技术要求，平台开放，方便二次开发与应用扩展",
            link: "实时物联",
            link_detailed: "可与IIoT平台对接，支持硬件设备快速连接，实时采集数据，控制设备运行，实现制造闭环",
            data: "大数据应用",
            data_detailed: "采用行业领先的工业大数据平台解决方案，满足数字化处理需求，稳定高效",
            modular: "模块化",
            modular_detailed: "开放平台，微服务集群架构，低耦合，高扩展性，搭建应用如同搭积木一样简单",
            flexible: "部署灵活",
            flexible_detailed: "支持云上部署、本地化部署，跨地域多区域部署",
            architecture: "创新的产品架构",
            architecture_detailed: "MES采用行业领先的微服务架构，提供开放的业务中台技术，可扩展性高，IIoT物联平台提供设备实时接入 ，实现全流程数字化管理，同时兼容工业大数据处理平台，为未来智能工厂发展提供保障。",
            features: "全面的功能特性",
            features_detailed: " 根据业务需要，各功能模块可拆分与合并，灵活组合，主要功能有：生产管理、质量管理、工程管理、防错追溯、报表管理、可视化、系统集成",
        },
        npm: {
            choose: "为什么选择一道NPM",
            time: "丰富的NPM技术积累",
            detailed: "多年世界500强企业NPM经历，培养了独具一格的视角，积累了丰富的实战经验",
            print: "流程过程可视化",
            print_detailed: "根据试用流程特殊性，创建专用的管控流程，自动化数据采集与分析，可视化程度高",
            link: "业务多样性",
            link_detailed: "系统支持二次开发与嵌入集成，如集成Vayo NPI系列工具后，可进行DFM分析，钢网设计等，大幅提高了试制效率",
            data: "大数据应用",
            data_detailed: " 采用行业领先的工业大数据平台解决方案，满足数字化处理需求，稳定高效",
            modular: "模块化",
            modular_detailed: "开放平台，微服务集群架构，低耦合，高扩展性，搭建应用如同搭积木一样简单",
            flexible: "部署灵活",
            flexible_detailed: "支持云上部署、本地化部署，跨地域多区域部署",
            architecture: "试制全流程管控",
            architecture_detailed: " 从建立试制产品管理流程开始，监控到每个试制环节，并建立多种分析模型，智能分析问题，查找或提出解决方案并固化到数字化知识库，为产品研发或量产提供有力保障。",
            establish: "建立多种分析模型",
            smart: "智能分析问题",
            solve: "提出解决方案",
            curing: "固化数字化知识库",
        },
        iiot: {
            choose: "为什么选择一道IIoT",
            time: "9年+技术积累",
            detailed: "历经多年技术研究，培养了一批专业技术人员，积累了丰富的物联实战经验",
            print: "连接设备多样性",
            print_detailed: " 超过100种设备，2000台设备的连接，覆盖SMT/DIP/TEST/AGV等工艺流程中绝大多数设备",
            link: "业务多样性",
            link_detailed: " 物联平台支持深度二次开发，如设备管理、维护管理、TPM等应用扩展",
            data: "大数据应用",
            data_detailed: "采用行业领先的工业大数据平台解决方案，满足数字化处理需求，稳定高效",
            modular: "模块化",
            modular_detailed: "开放平台，微服务集群架构，低耦合，高扩展性，搭建应用如同搭积木一样简单",
            flexible: "部署灵活",
            flexible_detailed: "支持云上部署、本地化部署，跨地域多区域部署",
            architecture: "先进的产品架构",
            architecture_detailed: " 一道IIoT产品架构主要有四层：设备层、接入层、数据层和应用层，参数配置化程序高，配合智能网关等硬件，可实现设备全覆盖连接。配合大数据处理平台，轻松实现设备全生命周期管理。",
            features: "全面的功能特性",
            features_detailed: "通过设备接口封装库，简单配置即可实现设备连接，采集数据在边缘计算中心处理，可减少服务器压力，数据可实时传输到数字化看板或报表系统，为管理人员提供参考。",
        },
        npi: {
            choose: "为什么选择Vayo NPI",
            time: "20年+技术积累",
            detailed: "望友历经多年自主研发，拥有数十项专利和产品版权，超过20多个国家和地区在使用产品",
            print: "产品全面",
            print_detailed: "目前望友的NPI系列软件产品主要有:DFM、SMT、Test、Stencil、Document、View、SPI",
            link: "应用范围广",
            link_detailed: " 涉及的行业领域涵盖通讯网络、计算机技术、消费电子、汽车及部件、轨道交通、能源、安防、医疗、工业互联设备、教育等",
            data: "平台应用",
            data_detailed: " 采用行业领先的工业大数据平台解决方案，满足数字化处理需求，稳定高效",
            modular: "客制化服务",
            modular_detailed: "提供特殊需求定制服务，原生系统二次开发，运行稳定高效",
            flexible: "部署灵活",
            flexible_detailed: "支持云上部署、本地化部署，跨地域多区域部署",
            architecture: "Vayo数字化工艺平台架构",
            architecture_detailed: " 工艺平台的价值：工艺Know-how数字化，工艺设计/准备标准化，传承经验、简化管理，加速NPI、加速产品上市。",
            features: "电子系统数字化设计-制造一站式工业软件方案"

        },
    },
    case: {
        // 客户案例
        haoen: {
            name: "豪恩集团",
            business: "汽车电子",
            title: "主营业务简介",
            details: "深圳市豪恩科技集团股份有限公司(以下简称“豪恩集团”)创建于1995年，是一家致力于创新设计，高品质服务，为客户提供智能产品全方位解决方案的科技集团公司。公司主要从事汽车电子、LED智能照明产品、智能物联等产品的研发、生产和销售，为国内外众多一流企业提供专业配套服务。集团总部位于深圳市豪恩科技园，旗下拥有豪恩汽电、豪恩智联等多家公司，其中豪恩智联已于2016年在新三板成功挂牌，证券代码835721",
            module: "应用模块",
            wms: "原材料管理、半成品、成品管理、SAP数据同步",
            mes: "工程管理、生产防错追溯、治工具管理、生产管理看 板、DIP及组装测试追溯",
            qms: "质量管理、SPC、QTIME",
            iot: "智能货架/镭雕机/烘烤柜/温湿度监控仪/上板机/印刷机/SPI/NPM贴片机/AOI/ERSA回流炉/下板机/X-ray/ICT/返修台/分板机/自动烧录机/组包装测试 /自动化测试仪/点胶机/密封性测试仪/FCT/老化柜/镜头对焦仪/ERSA选择性波峰焊",
            cloud: "供应商云注册平台",
        },
        huayang: {
            name: "华阳通用",
            details: "惠州华阳通用电子有限公司是惠州市华阳集团股份有限公司（股票代码：002906）全资子公司，成立于2002年，是一家专注汽车电子研发、生产与销售的国家级高新技术企业。公司致力于为客户提供智能座舱域与智能驾驶域的产品及服务，包括信息娱乐、液晶仪表、屏显示类、座舱域控制器、空调控制器、车联网服务、360环视、自动泊车、其它驾驶辅助系统等。业务范围涵盖海外OEM/ODM、自主品牌（FORYOU/ADAYO）及国内前装车厂等；拥有雄厚的技术力量、完善的制造系统和卓越的品质保证系统，专注于音效处理、图像处理、导航定位、人机交互、智能语音控制、智能互联及高级驾驶辅助等领域。",
            iot: "上板机/印刷机/SPI/ASM贴片机（生产料表、实时耗料、低位预警、机器状态等）/AOI/回流炉",
            emis: "：MES系统集成",
        },
        zhuoao: {
            name: "卓奥股份",
            business: "白色家电",
            details: "浙江卓奥科技股份有限公司成立于2007年，公司专业从事微电脑智能控制器的设计开发、生产、销售为一体，主要服务于家用电器（大小家电）、自动化设备与工业控制系统、环保与医疗、新能源应用等领域。公司为全国中小企业股份转让系统（新三板）挂牌企业(证券简称“卓奥科技”，证券代码：“872337”)、国家高新技术企业、市级工程技术中心、区级高成长企业。",
            mes: "合作E-MES，从仓库管理、SMT生产防错追溯、AI自动插件放错追溯、生产管理看板、DIP及组装测试等追溯",
            iot: "ERP/OA/仓库智能货架/镭雕机/烘烤柜/SMT印刷机/SPI/贴片机/AOI/立式插件机/卧式插件机/X-ray/ICT/返修台/点胶机/DIP波峰焊/FT、组包装测试/自动化测试仪/贴标机/点胶机/FCT/老化柜/称重仪",
            itm: "深信服超融合一体机/防火墙"
        },
        changcheng: {
            name: "长城开发",
            business: "电子领域",
            details: "深圳长城开发科技股份有限公司（证券简称：深科技 证券代码：000021）为全球客户提供技术研发、工艺设计、生产控制、采购管理、物流支持等全产业链服务。1994年在深交所上市。深科技成立于1985年，拥有30多年丰富的产品生产制造经验，1.5万平方米10000级到100级的净化车间，160多条SMT生产线。公司总部位于中国深圳，拥有深圳、苏州、惠州、东莞、成都、重庆、桂林、合肥、马来西亚、菲律宾等十个研发制造基地，总面积超过58万平方米。同时公司在美国、英国、荷兰、印度、新加坡、香港等十多个国家或地区设有分支机构或拥有研发团队，现有员工约2.6万人。",
            kbs: "数字化集控中心，数据可视化展示",
            iot: "SMT 印刷机/Reflow回流炉",
            npi: "SMT快速编程软件，加速离线编程效率和提高编程质量"
        },
        huarong: {
            name: "华荣通信",
            business: "基础通信",
            details: "深圳市华荣科技有限公司成立于2001年8月，是华为技术有限公司及其关联公司的战略合作伙伴，其核心业务是通信和网络安全、存储产品的EMS业务。东莞市华荣通信技术有限公司是深圳市华荣科技有限公司的全资子公司，于2009年9月正式投产。公司厂区建筑面积约51000多平方米，目前员工总人数1000多人，年产值数亿元。",
            details2: " 公司近年来获得的荣誉： 2010年度获得客户授予的“供货支持奖”称号/2009年度获得宝安区政府授予的“宝安区百强民营企业”称号/ 2009年度获得客户授予的“供货支持奖”称号/2008年度获得客户授予的“供货支持奖”称号/2006年度获得客户授予的“金牌供应商”称号。公司的主要业务：通信产品机柜、模块的设计和制造/ 通信产品的整机组装和测试 /网络安全、存储产品的组装和测试",
            wms: "原材料管理、半成品、成品管理、SAP数据同步",
            mes: "工程管理、生产防错追溯、治工具管理、生产管理看板、DIP及组装测试追溯",
            qms: "质量管理、SPC、QTIME",
            iot: "智能货架/镭雕机/烘烤柜/温湿度监控仪/上板机/印刷机/SPI/ASM贴片机/AOI/回流炉/下板机/X-ray/ICT/返修台/分板机/自动烧录机/组包装测试/自动化测试仪/FCT/老化柜/钢网检测机",
            huawei: "华为云集成、华为供应商管理系统集成"
        },
        kangyuan: {
            name: "康源电子",
            details: " 康源电子始建于1977年，总部位于香港。1993年在虎门建厂投产，2008年转型为外商独资，现已成为一个拥有10万平方厂房、1800名智慧员工的专业印刷电路板制造商，并于2010年荣获“国家高新技术企业”认证。公司专注于高端PCB和FPC产品的工艺研发、产品制造和销售，主要产品包括高密度互连积层板、多层挠性板、刚挠性印刷电路板、封装载板、HDI和高新科技领域电路板，广泛应用于通讯、汽车、消费、工业、医疗等领域，客户遍布北美、欧洲、中国及亚太等地区。",
            iot: "仓库智能货架/镭雕机/烘烤柜/温湿度监控仪/SMT锡膏回温柜/上板机/DEK/GKG印刷机/接驳台/SPI/贴片机/AOI/回流炉/下板机/X-ray/ICT/线边物料存储柜/BGA返修台/分板机/钢网清洗机/治具清洗机/激光打标机/离线烧录机/组包装测试/自动化测试仪/螺丝机/贴标机/FCT"
        },
        weixin: {
            name: "威新电子",
            business: "消费类电子",
            details: "威新科技采用现代企业管理体系运作，致力于智能通讯产品、汽车电子、医疗电子、光通讯产品的生产制造，力求打造成超精密PCBA/EMS方案商。威新科技拥有员工500多人和6000平方米的现代化标准厂房，有SMT产线12条（双轨），自动测试线7条，手动测试线12条。公司拥有全球最顶级的SMT设备和专业的SMT人才，提供专业的DFM服务和丰富的01005元器件、POP工艺技术，小天才智能儿童手表PCBA代工商。",
            iot: "智能货架/镭雕机/烘烤柜/温湿度监控仪/上板机/印刷机/SPI/FUJI贴片机/AOI/回流炉/下板机/X-ray/ICT/返修台/分板机/自动烧录机/组包装测试 /自动化测试仪/FCT ",
            emis: "小天才系统集成",
        },
        hainengda: {
            name: "海能达股份",
            business: "基础通信",
            details: "海能达通信股份有限公司（股票代码：002583.SZ）是总部位于中国深圳的全球化民营上市公司，1993年成立，是全球领先的专用通信及解决方案提供商，致力于为公共安全、应急、能源、交通、工商业等行业客户，在日常工作与关键时刻，提供更快、更安全、更多联接的通信设备及解决方案，助力城市更高效、更安全。",
            iot: "PN编码自动切换/程式自动化切换/ASM贴片机/Panasonic贴片机/Feeder管理系统/AOI/海能达自研MES系统",
            mes: "PN及程式自动化切换ASM/Panasonic/AOI ",
            npi: "SMT智能编程"
        },
        jinghua: {
            name: "精华电子",
            title: "主营业务简介",
            business: "汽车电子",
            details: "精华电子（苏州）有限公司隶属于华科事业群，公司成立于2001年，位于苏州高新区金枫路183号，厂区建筑面积达4.5万平方米。注册资本额3,850万美元。芜湖分公司位于安徽省芜湖市弋江区花津南路108号，土地面积6.3万平方米。公司为新能源、汽车、工控行业的专业制造商，为客户提供自PCBA到成品组装的EMS服务。并与一线车企深度合作，一线方案商深度绑定，为客户提供高质量，高效率，高附加价值的整合服务。精华电子（苏州）有限公司已被评定为国家级高新技术企业、 A级劳动保障诚信单位、苏州市劳动关系和谐企业、职业技能等级认定企业。拥有国家级实验室。通过了系列品质认证:ISO9001:2008,ISO14001,OHSAS18001,QC080000, TS16949 (IATF), ISO13485, ESDS 20.20, IPC QML;ISO/IEC 27001:2013等。主营业务产品有BMS、VCU、MCU、ADAS、域控制器、重工机械控制器等。",
        },
        hangsheng: {
            name: "航盛电子",
            title: "主营业务简介",
            business: "汽车电子",
            details: "深圳市航盛电子股份有限公司创立于1993年，是中国汽车电子行业的龙头企业之一，产品阵容覆盖智能座舱、智能驾驶、网联与软件服务系统、新能源汽车控制电子、汽车音响系统等产品，是国家级高新技术企业，拥有国家认定的企业技术中心、国家CNAS认可实验室、博土后工作站，先后获得广东省政府质量奖、深圳市市长质量奖、深圳市科学技术进步市长奖、“中国电子信息百强企业”、“广东省著名商标”、“广东省名牌产品”等荣誉，是深圳市首批四个卓越绩效示范基地之一。公司凭借管理精益化、研发创新化、生产智能化等核心竞争力，秉承“以客户为中心”的理念，为一汽丰田、广汽丰田、东风日产、东风本田、广汽本田、一汽大众、上汽大众、江淮大众、神龙汽车、北京现代、一汽红旗、东风岚图、上汽乘用车、广汽埃安、小鹏汽车、理想汽车、蔚来汽车、哪吒汽车、大众汽车、法国标致雪铁龙、日产汽车，丰田汽车，本田汽车，铃木汽车等国内外汽车厂商提供高质量的产品和优质的服务。",
        },
        lixun: {
            name: "立讯精密",
            title: "主营业务简介",
            business: "基础通讯",
            details: "东莞立讯技术有限公司是中国领先的通讯设施和企业级互连产品提供商，立讯精密下属子公司，是5G通讯设备和企业级互连解决方案的全球设计商和制造商。公司主要生产经营基站天线、滤波器、RRU等通讯设备，以及连接器、连接线、光模块、AOC等互连产品，基于创新的设计，辅以智能制造和深厚的合作伙伴关系，与技术领导者协同开发互连行业的创新解决方案，让连接更敏捷。立讯技术的业务范围覆盖全球通讯及企业级客户群，在美洲、欧洲、日本均有销售服务团队和研发中心，可以提供全球范围内互连解决方案的快速响应和现场支撑；同时完整的信息化平台可以让员工随时随地获取到最完整的产品信息和互连解决方案，更便捷的服务客户。产品已经覆盖无线通信基站、数据中心、服务器、交换机、路由器等应用领域，提供完整的从无线连接，到电连接、光连接、热管理等完整互连解决方案。",
        },
        sanjiang: {
            name: "三江电子",
            title: "主营业务简介",
            business: "消费类电子",
            details: "深圳市高新投三江电子股份有限公司创立于1985年，是国家级高新技术企业。作为国内最早从事智能消防报警设备研发的企业之一，公司研发制造了中国第一代离子感烟探测器、首个超大容量火灾自动报警系统。依托完善的研、产、销及服务一体化业务体系，公司面向国内外市场提供火灾自动报警系统、消防设备电源监控系统、电气火灾监控系统、气体灭火控制系统、可燃气体报警系统、消防应急照明和疏散指示系统、防火门监控系统、余压监控系统、消防物联网平台与终端等成套设备，以及为特殊场所或行业提供定制化解决方案。深圳市高新投三江电子股份有限公司坚持以新一代信息技术为导向，持续保持大比重的研发投入：在硬件设施方面，已建成设备配置先进的专业实验室、系统运行室、模拟环境演示室等科研设施；在人才培育方面，通过汇聚行业内各类高端技术型人才，组建高标准的研发技术团队，保证了产品技术在市场上的领先地位。公司拥有多项行业领先技术及云计算、大数据、深度学习、智能维护等前瞻技术，并广泛应用于高安全级别的消防安全保障领域。",
        },
        nanruijibao: {
            name: "南瑞继保",
            title: "主营业务简介",
            business: "电力装备",
            details: "南京南瑞继保电气有限公司（简称“南瑞继保”）主要从事电力保护控制、智能电力装备和工业过程控制的研发和产业化，是国家重点高新技术企业、国家技术创新示范企业，中宣部确定的企业自主创新全国重大宣传典型。获评国家卓越工程师团队、国家制造业单项冠军、国家智能制造示范工厂、国家绿色工厂、江苏省省长质量奖、江苏省优秀企业。中国工程院沈国荣院士担任公司董事长。总部设在南京，在南京和常州两地建有科研和产业化基地，在北京、广州、西安等8个地区设有国内区域销售和技术服务中心，在英国、印度尼西亚、马来西亚、尼日利亚等地设立了各大洲的国际分支机构和本地化的技术服务中心。以务实解决实际问题为创新理念，南瑞继保在继电保护、电网安全稳定控制、特高压交直流输电和柔性交直流输电等领域取得了一批支撑和引领行业发展的研发成果。迄今已完成重大研究开发项目338项；获得国家科技进步特等奖1项、国家科技进步奖一等奖1项、国家科技进步奖二等奖4项、国家发明奖二等奖2项、省部级科技进步特等奖2项、省部级科技进步奖一等奖25项；累计获得有效专利2595件，其中国内专利授权2185件，国外专利授权410件；主导和参与编制发布国际标准15项、国家标准171项、行业标准186项。南瑞继保核心产品市场占有率高，继电保护产品在220kV及以上电压等级的国内市场占有率近40%，产品广泛应用于三峡输变电、“西电东送”、北京奥运、上海世博、杭州G20等国家重点工程。公司的继电保护、电网安全稳定控制、高压交直流输电控制保护等技术打破了国外公司的长期技术和产品垄断，以其先进性、实用性和可靠性，提高了我国电网安全稳定运行水平。",
        },
        zechen: {
            name: "则成电子",
            title: "主营业务简介",
            business: "消费类电子",
            details: "深圳市则成电子股份有限公司（股票简称及代码：则成电子837821），为国家高新技术企业，从事基于柔性运用的定制化智能控制模块产品的研发、生产与销售，已成为众多世界500强公司的合格供应商。则成电子拥有智能模组模块、电子装联、印制电路板三项基本业务，形成了业界独特的业务布局。产品覆盖消费电子、医疗电子、生物识别及汽车电子等多个领域。2022年7月6日，北交所的则成电子上市，发行价为10.8元/股，发行市盈率为23.82倍。",
        },
        hengtianweiyan: {
            name: "恒天伟焱",
            title: "主营业务简介",
            business: "消费类电子",
            details: "深圳市恒天伟焱科技股份有限公司 (曾用名：深圳市恒天伟焱科技有限公司) ，成立于2005年，位于广东省深圳市，是一家以从事计算机、通信和其他电子设备制造业为主的企业。",
        },
        shennandianlu: {
            name: "深南电路",
            title: "主营业务简介",
            business: "消费类电子",
            details: "深南电路股份有限公司成立于1984年,主要生产加工印制线路板(PCB),高密度,以及提供SMT产品装配服务. 每月PCB产能达14万平米。产品广泛应用于通讯,医疗,汽车电子,航空航天,工控等领域.为客户提供一站式服务,发挥全价值链的协同效应",
        },
    },
    introduce: {
        // 公司介绍
        about: "  公司成立于2012年，是一家创新型软件及信息技术服务商，“双高新”企业（国家高新&深圳高新技术企业），是中国智能制造探索者和践行者，致力于制造细分行业—电子制造业的数字化转型服务，构建万物互联的智能工厂。",
        about2: "一道创新致力于把先进的软件系统、数字平台、人工智能赋能智能工厂，让无处不在的联接成为智能工厂的基础，让企业因强大的数字平台而变得敏捷、高效，推动传统的制造业向服务型制造业转型，拉近消费者与制造工厂的距离，为消费者提供个性化智慧制造服务。",
        vision: "愿景",
        etao: "把数字带入制造的每个环节，构建万物互联的智能工厂",
        technology_title: "技术储备",
        technology: "公司吸纳了诸如Siemens、华为以及其他SMT行业公司等全方位的技术人才，使公司底蕴更加浑厚；",
        invent: " 公司鼓励创新与发明，多次解决软件行业在应用领域存在的技术问题诸如大数据快速访问、人员精准定位、智能排产等问题，并累积了众多紧密合作的供应商；SMES系统框架升级至3.0，涵盖了电子行业的标准数据结构，并封装至研发库与SDK包中。这些SDK可支撑未来系统扩建与组装，是团队经验与智慧的结晶；基于EMIS平台开发国内本土化软件，快速积累庞大的行业和软件经验，长期为国内电子设计及电子制造提供软件服务；",
        emis: "基于EMIS标准框架，分别为小型民营企业、国营企业、中型企业、外资企业，华南、华北、华东等地区电子工厂提供MES模块定制开发和服务，累计了多元化的客户需求案例和经验。",
        course: "发展历程",
        certificate: "资质证书",
    },
    recruitment: {
        // 人才招聘
        looking: "我们正在寻找这样的你",
        java_engineer: {
            java: "Java开发工程师",
            jobs: "岗位职责",
            duties: "深入理解业务需求，参与系统架构设计，参与技术可行性分析以及系统概要设计；",
            duties2: "分析与识别系统优化点，提出优化方案与建议，参与性能优化；",
            duties3: "负责模块详细设计、代码编写以及相关代码重构工作；",
            duties4: "工程师之间积极知识分享，参与Code Review；",
            duties5: "独立解决各类技术问题，包括性能问题、安全问题以及棘手功能性问题。",
            require: "任职要求",
            require_details: "全日制本科学历以上，计算机相关专业；",
            require_details2: "3年及以上Java开发经验，扎实的Java编程基础，精通JavaEE、SOA、MVC 等相关技术；",
            require_details3: "熟练微服务框架，如Spring、Cloud、 Alibaba、Dubbo、Nacos、Hystrix、Zipkin等，对框架本身有过开发或重构者可优先考虑；",
            require_details4: "熟练使用Redis、MongoDB、MySQL、Kafka、ActiveMQ等；",
            require_details5: "较强的沟通和表达能力，对系统质量有近乎苛刻的要求；",
            require_details6: "工作认真严谨敬业，勇于创新和接受挑战，具备创业精神。"
        },
        project_engineer: {
            project: "项目实施工程师",
            duties: "负责智能工厂MES、WMS项目现场系统实施工作，配合项目经理完成项目调研、方案设计、过程实施、上线推广、项目验收；",
            duties2: "配合项目经理通过项目管理工具和方法，对项目进度进行控制与调整，确保项目按计划按时保质完成；",
            duties3: "项目实施过程中能够及时发现问题并反馈研发优化，支持产品不断完善；",
            duties4: "保持公司内部及客户方项目组成员的良好沟通，跨部门的协调工作，共同为项目过程和结果负责；",
            duties5: "及时进行项目总结，归档项目文件，主动按要求上报反馈项目进度。",
            require_details: "大专或以上学历，计算机、软件、管理类相关专业；",
            require_details2: "两年电子制造行业工作经验；",
            require_details3: "熟悉软件项目实施的方法论，及MES、WMS相关项目管理经验优先；",
            require_details4: "有良好的团队精神和严谨的工作态度，能承受工作压力，能适应出差；",
            require_details5: "有较强的表达、沟通能力、逻辑思维能力、组织协调能力、文档管理能力；",
            require_details6: "优秀毕业生或社会从业者可适当放宽条件；",
            require_details7: "有电子制造行业工作经验优先"
        },
        product_manager: {
            product: "产品经理",
            duties: "负责智能工厂MES、WMS项目管理工作，具备项目调研、方案设计、过程实施、上线推广、项目验收全流程管控能力；",
            duties2: "通过项目管理工具和方法，对项目进度进行控制与调整，确保项目按计划按时保质完成；",
            duties3: "项目实施过程中能够及时发现问题并反馈研发优化，支持产品不断完善；",
            duties4: "保持公司内部及客户方项目组成员的良好沟通，跨部门的协调工作，共同为项目过程和结果负责；",
            duties5: "及时进行项目总结，归档项目文件，控制项目进度。",
            require_details: "本科以上学历，计算机、软件、管理类相关专业，3-5年电子制造行业工作经验；",
            require_details2: "熟悉软件项目实施的方法论，有MES、WMS相关项目管理经验优先；",
            require_details3: "具有较强的产品规划能力和方案制定能力，熟悉制造业流程，能针对不同业务场景设计合理的解决方案；",
            require_details4: "有良好的团队精神和严谨的工作态度，能承受工作压力，能适应出差；",
            require_details5: "有较强的表达、沟通能力、逻辑思维能力、组织协调能力、文档管理能力。",
        },
        product_assistant: {
            assistant: "产品经理助理",
            duties: "协助优化已有功能以提升用户体验，并撰写高质量的产品需求文档与产品原型图，编写PRD文档，确保技术及业务部门准确理解；",
            duties2: " 协助产品经理参与产品功能设计、原型设计，交付至设计团队进行视觉及交互设计，并协助组织需求及设计评审，跟进研发和交付；",
            duties3: "根据安排了解业务，与业务方积极沟通，理解和挖掘客户的详细业务需求，并根据需求提供可行合理的解决方案。",
            require_details: "本科以上学历，电子、计算机、机械等等相关专业；",
            require_details2: "1年以上工作经验；",
            require_details3: "具备撰写产品文档的能力，以及产品规划、需求分析、系统化设计的能力;能熟练运用Office、Visio、Axure、XMind等相关的办公软件；",
            require_details4: "极强的执行力，能协调团队，快速的将产品功能上线迭代；",
            require_details5: "有开发经验或者有制造行业工作经历优先。",
        },
        project_manager: {
            project: "项目经理",
            duties: "负责智能工厂MES、WMS项目管理工作，具备项目调研、方案设计、过程实施、上线推广、项目验收全流程管控能力；",
            duties2: " 通过项目管理工具和方法，对项目进度进行控制与调整，确保项目按计划按时保质完成；",
            duties3: "项目实施过程中能够及时发现问题并反馈研发优化，支持产品不断完善；",
            duties4: "保持公司内部及客户方项目组成员的良好沟通，跨部门的协调工作，共同为项目过程和结果负责；",
            duties5: "及时进行项目总结，归档项目文件，控制项目进度。",
            require_details: "大专或以上学历，计算机、软件、管理类相关专业，3-5年电子制造行业工作经验；",
            require_details2: "熟悉软件项目实施的方法论，有MES、WMS相关项目管理经验优先；",
            require_details3: "具有较强的产品规划能力和方案制定能力，熟悉制造业流程，能针对不同业务场景设计合理的解决方案；",
            require_details4: "有良好的团队精神和严谨的工作态度，能承受工作压力，能适应出差；",
            require_details5: "有较强的表达、沟通能力、逻辑思维能力、组织协调能力、文档管理能力。",
        },
        internship_work: {
            internship: "实习岗",
            duties: "公司安排项目跟进学习培训，轮岗实习，指定导师培养；确保进入企业后能快速成长，优秀者可以优先晋升，你的能力决定你的发展；",
            duties2: " 公司不定期举行管理岗、核心技术岗公开竞聘和内部岗位优先推荐，优先确保其晋升和发展；",
            duties3: "岗位方向：销售/售前顾问、经理助理、开发工程师、项目经理、项目工程师、实施工程师、算法工程师；",
            duties4: "晋升转岗后薪资待遇按岗位定薪标准执行。",
            require_details: "计算机、信息管理、软件工程、工业自动化等相关专业；",
            require_details2: "党员及学生干部优先；",
            require_details3: "语言表达能力突出，有较强的抗压能力和团队合作能力；",
        },
        recruitment: {
            title: "我们的招聘流程",
            delivery: "简历投递",
            interview: "待简历收到后的两天时间内，我们会电话联系您，安排面试",
            offer: "通过所有面试环节后，您将收到我们的offer"
        }
    },
    contact: {
        // 联系我们
        title: "联系我们",
        company: "公司成立于2012年，专注电子领域，深耕工业物联9年，可以自主完成大于100种设备的数据采集，不用再担心上系统踩到数据采集的坑，导致项目烂尾。产品覆盖从设计到制造全流程，满足未来的BS+微服务集群架构，开源的物联平台，让设计更懂制造，制造更懂设计。",
        call: "联系地址",
        address: "深圳市龙岗区天安云谷6栋东座506",
        consulting: "咨询热线",
        email: "联系邮箱",
        code: "扫一扫关注公众号"
    }
}
